import React from "react";
import { bytesToSize, downloadFile } from "../functions";

export function ReciveFile({ t, message, recipient, time }) {
    if (!message) return null;
    const { name, size } = message;
    const downloadLink = message?.downloadLink;

    const handlerDownloadFile = () => {
        const file = downloadFile(downloadLink, name);
        if (!file) alert(t("common.error"));
    };
    
    return (
        <>  
            <div className="message_text">
                <p className="sender">
                    {recipient}
                    <span style={{margin: "0 6px", fontSize: "10px"}}>{time}</span>
                </p>
                <p className="message_context"> {name} </p> 
            </div>
            <div className="message_file" onClick={handlerDownloadFile}>
                <span className="icoImg message_download">
                    <span className="blind">{ t("chat.download") }</span>
                </span>
                <span>{downloadLink ? `${bytesToSize(size)}` : t("chat.sending")}</span>
            </div>
        </>
    )
}